var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.22222C0 0.994923 0.976833 0 2.18182 0C3.3868 0 4.36364 0.994923 4.36364 2.22222C4.36364 3.44952 3.3868 4.44444 2.18182 4.44444C0.976833 4.44444 0 3.44952 0 2.22222ZM7.63636 2.22222C7.63636 0.994923 8.6132 0 9.81818 0C11.0232 0 12 0.994923 12 2.22222C12 3.44952 11.0232 4.44444 9.81818 4.44444C8.6132 4.44444 7.63636 3.44952 7.63636 2.22222ZM0 10C0 8.7727 0.976833 7.77778 2.18182 7.77778C3.3868 7.77778 4.36364 8.7727 4.36364 10C4.36364 11.2273 3.3868 12.2222 2.18182 12.2222C0.976833 12.2222 0 11.2273 0 10ZM7.63636 10C7.63636 8.7727 8.6132 7.77778 9.81818 7.77778C11.0232 7.77778 12 8.7727 12 10C12 11.2273 11.0232 12.2222 9.81818 12.2222C8.6132 12.2222 7.63636 11.2273 7.63636 10ZM0 17.7778C0 16.5505 0.976833 15.5556 2.18182 15.5556C3.3868 15.5556 4.36364 16.5505 4.36364 17.7778C4.36364 19.0051 3.3868 20 2.18182 20C0.976833 20 0 19.0051 0 17.7778ZM7.63636 17.7778C7.63636 16.5505 8.6132 15.5556 9.81818 15.5556C11.0232 15.5556 12 16.5505 12 17.7778C12 19.0051 11.0232 20 9.81818 20C8.6132 20 7.63636 19.0051 7.63636 17.7778Z",
    fill: "#7D7D82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.404858825a2248afabbd9e8ce9888816.svg";
export { ForwardRef as ReactComponent };